import { Hero, TrustBar } from "../sections/Hero";
import { AboutSection, HowIThinkSection } from "../sections/About";
import { ProjectsSection, MetricsSection } from "../sections/Work";
import { ServicesSection, TestimonialsSection } from "../sections/Services";
import { BlogSection } from "../sections/Insights";
import { ContactSection } from "../sections/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustBar />
      <HowIThinkSection />
      <AboutSection />
      <ProjectsSection />
      <MetricsSection />
      <ServicesSection />
      <TestimonialsSection />
      <BlogSection />
      <ContactSection />
    </main>
  );
}
